import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody, Form } from "reactstrap";
import Select from "react-select";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Loader from "pages/Separate/Loader";
import configure from "configure";
import { fetchData, fetchNodeData, FetchNodePostData } from "utils/common-fetchData";
import confirmImg from "../../../assets/images/confirmImg.jpg";
import secureLocalStorage from "react-secure-storage";
import Draggable from "react-draggable";
import { ResizableBox } from "react-resizable";
import Swal from "sweetalert2";
import moment from "moment";

const CustomerDetail = ({getFetchStep}) => {
  const [isLoading, setLoading] = useState(false);
  const [country_option, setCountryOption] = useState([]);
  const [state_option, setStateOption] = useState([]);
  const [city_option, setCityOption] = useState([]);
  const [location_option, setLocationOption] = useState([]);
  const [company_name, setCompany_name] = useState("");
  const [vat_number, setVatNumber] = useState("");
  const [location, setLocation] = useState([]);
  const [source, setSource] = useState([]);
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [country, setCountry] = useState([]);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [address, setAddress] = useState("");
  const [zip_code, setZipCode] = useState("");
  const [groups, setGroups] = useState([]);
  const [currency_option, setCurrencyOption] = useState([]);
  const [currency, setCurrency] = useState([]);
  const [incorporation, setIncorporation] = useState("");
  const [customer_option, setCustomerOption] = useState([]);
  const [customer_name, setCustomerName] = useState([]);
  const [profile, setProfile] = useState("");
  const [image, setImage] = useState("");
  const [invoice, setInvoice] = useState(false);
  const [allSoucrce, setAllSource] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const [ztplInvoice, setZtplInvoice] = useState([]);
  const [zithasInvoice, setZithasInvoice] = useState([]);
  const [modalPromise, setModalPromise] = useState(null);

  const params = useParams();
  const token = secureLocalStorage.getItem("auth_token");


  const colourStyles = {
    menuList: (styles) => ({
      ...styles,
      background: "white",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 50,
    }),
  };

  const groups_option = [
    { label: "Regular", value: "1" },
    { label: "Monthly", value: "2" },
    { label: "Quarterly", value: "3" },
  ];

  const toggleLoading = (loading) => {
    setLoading(loading);
  };



  const onEditCustomer = async (e) => {
    e.preventDefault();
    const formEntries = {
      id: params?.id,
      website: website,
      groups: groups?.value,
      corporationdate: moment(incorporation)?.isValid() ? incorporation : null,
      profile_pic: profile,
      user_id: localStorage.getItem('auth_id')
    }
    const res = await FetchNodePostData(setLoading , 'convertToPermanent' , token , formEntries);
    if(res?.data?.success){
      Swal.fire({
        icon:"success",
        text:"New Customer has been created Successfully"
      })
      getFetchStep()
    }
  };

  useEffect(() => {
    FetchProposalData();
  }, [params.id]);

  const FetchProposalData = async () => {
    setLoading(true);
    const response = await fetchNodeData(setLoading, `tempCustomer/${params.id}`, token);
    if (response?.success) {
      const customerDetails = response?.data
      setLocation(customerDetails?.location)
      setCompany_name(customerDetails?.company)
      setVatNumber(customerDetails?.vatnumber)
      setPhone(customerDetails?.phone)
      setAddress(customerDetails?.address)
      setZipCode(customerDetails?.zipcode)
      setEmail(customerDetails?.email)

      await axios({
        method: "get",
        url: `${configure.apiUrl}/locations`,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        const option = res?.data?.data?.map((obj) => ({
          label: obj.location,
          value: obj.id,
          ...obj
        }));
        setLocationOption(option);
        setLocation(customerDetails?.location);
      });

      await axios({
        method: "get",
        url: `${configure.apiUrl}/currency`,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        const option = res?.data?.data?.currency?.map((item) => ({
          label: item.currency,
          value: item.id,
        }));
        setCurrencyOption(option);
      });

      await axios({
        method: "get",
        url: `${configure.apiUrl}/country`,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        const option = res?.data?.data?.country?.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setCountryOption(option);
        setCountry(
          option.find(
            (obj) => obj.value == customerDetails?.country
          )
        );
      });

      const formData = new FormData();
      formData.append("country_id", customerDetails.country);
      const res = await axios({
        method: "post",
        url: `${configure.apiUrl}/country_state`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        const options = res?.data?.data?.map((obj) => ({
          value: obj.id,
          label: obj.name,
        }));
        setStateOption(options);
        setState(
          options.find(
            (obj) => obj.value == customerDetails?.state
          )
        );
      });

      const formData2 = new FormData();
      formData2.append("state_id", customerDetails.state);
      const res2 = await axios({
        method: "post",
        url: `${configure.apiUrl}/state_city`,
        data: formData2,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        const options = res?.data?.data?.map((obj) => ({
          value: obj.id,
          label: obj.name,
        }));
        setCityOption(options);
        setCity(options.find((obj) => obj.value == customerDetails?.city));
      });

      const res3 = await fetchData(toggleLoading, "filter_data", token);
      if (res3?.success) {
        const allSources = [
          ...res3?.data?.india_source?.map((obj) => ({
            label: obj?.leadname,
            value: obj?.id,
            location: obj?.location,
          })),
          ...res3?.data?.uk_source?.map((obj) => ({
            label: obj?.leadname,
            value: obj?.id,
            location: obj?.location,
          })),
        ];
        const sources = allSources.find(
          (objs) => objs.value == customerDetails?.source
        );
        console.log(customerDetails, sources)
        setSource(sources);
        setAllSource(allSources);
        if (sources?.label?.toLowerCase() == 'customer' || sources?.label?.toLowerCase() == 'introducer') {
          const formDatas = new FormData();
          const sourcesLabel =
            sources?.label?.toLowerCase() == "customer"
              ? "0"
              : sources?.label?.toLowerCase() == "introducer"
                ? "1"
                : "";
          formDatas.append("location", customerDetails.location);
          formDatas.append("source_name", sourcesLabel);
          const res3 = await axios({
            method: "post",
            url: `${configure.apiUrl}/show_source`,
            data: formDatas,
            headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
            },
          }).then((res) => {
            setCustomerOption(
              res?.data?.data?.map((items) => ({
                value: items.id,
                label: items.company,
              }))
            );
            setCustomerName(
              res?.data?.data
                ?.map((items) => ({
                  value: items.id,
                  label: items.company,
                }))
                .find(
                  (obj) => obj.value == customerDetails?.source_name
                )
            );
          });
        }
      }
    }
    setLoading(false);
  };

  const onChangeCountry = async (e) => {
    setState([]);
    setCity([]);
    setLoading(true);
    setCountry(e);
    const formData = new FormData();
    formData.append("country_id", e.value);
    try {
      const res = await axios({
        method: "post",
        url: `${configure.apiUrl}/country_state`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        setLoading(false);
        setStateOption(
          res?.data?.data?.map((obj) => ({
            value: obj.id,
            label: obj.name,
          }))
        );
      });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const onChangeState = async (e) => {
    setLoading(true);
    setState(e);
    const formData = new FormData();
    formData.append("state_id", e.value);
    try {
      const res = await axios({
        method: "post",
        url: `${configure.apiUrl}/state_city`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        setLoading(false);
        setCityOption(
          res?.data?.data?.map((obj) => ({
            value: obj.id,
            label: obj.name,
          }))
        );
      });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const onGetSource = async (e) => {
    setCustomerOption([]);
    setSource(e);
    setLoading(true);
    const sources =
      e.label?.toLowerCase() == "customer"
        ? "0"
        : e.label?.toLowerCase() == "introducer"
          ? "1"
          : "";
    const formData = new FormData();
    formData.append("location", location);
    formData.append("source_name", sources);
    try {
      const res = await axios({
        method: "post",
        url: `${configure.apiUrl}/show_source`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        setLoading(false);
        setCustomerOption(
          res?.data?.data?.map((items) => ({
            value: items.id,
            label: items.company,
          }))
        );
      });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };


  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div>
        <div className="mb-3" style={{ padding: "0 11px 0 12px" }}>
          <form onSubmit={onEditCustomer}>

            <Row className="bg-white px-2 py-4 shadow mb-3">
              <div className="col-md-6">
                <div>
                  <h5 className="font-size-14 mb-4">Location</h5>
                  <div className="row" style={{ marginLeft: "0px" }}>
                    {location_option?.map((item, i) => (
                      <div className="form-check mb-2 col-md-2" key={i}>
                        <input
                          className="form-check-input input-location"
                          type="radio"
                          name="exampleRadios"
                          id={`radios${i}`}
                          value={item.value}
                          defaultChecked={location == item.value}
                          onChange={(e) => setLocation(e.target.value)}
                        />
                        <label
                          className="form-check-label pl-10"
                          htmlFor={`radios${i}`}
                        >
                          {/* {item.value == 1 ? ( */}
                          <img
                            src={item?.Link}
                            alt="no img"
                            width="28"
                            height="18"
                            style={{ marginTop: "2px" }}
                          />
                          {/* ) : (
                            <img
                              src={UkFlag}
                              alt="no img"
                              width="28"
                              height="18"
                              style={{ marginTop: "2px" }}
                            />
                          )} */}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="col-md-6 text-end">
                <button
                  className="btn ms-md-2 btn-save btn-label"
                >
                  <i className="fas fa-save me-1 label-icon"></i> save
                </button>
              </div>
            </Row>

            <Row className="bg-white px-2 py-4 shadow mb-3">
              <h5 className="mb-3">Company Information</h5>
              <div className="col-md-3 mb-3">
                <label htmlFor="">
                  Company <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter Company"
                  className="form-control"
                  value={company_name}
                  onChange={(e) => setCompany_name(e.target.value)}
                />
              </div>
              <div className="col-md-3 mb-3">
                <label htmlFor="">GST/VAT Number</label>
                <input
                  type="text"
                  placeholder="Enter GST/VAT Number"
                  className="form-control"
                  value={vat_number}
                  onChange={(e) => setVatNumber(e.target.value)}
                />
              </div>
              <div className="col-md-3 mb-3">
                <label htmlFor="">
                  Source <span className="text-danger">*</span>
                </label>
                <Select
                  placeholder="Select Source"
                  className="basic-multi-select"
                  classNamePrefix="select"
                  styles={colourStyles}
                  options={allSoucrce?.filter(
                    (obj) => obj?.location == location
                  )}
                  value={source}
                  onChange={(e) => {
                    if (
                      e.label?.toLowerCase() == "customer" ||
                      e.label?.toLowerCase() == "introducer"
                    ) {
                      onGetSource(e);
                    } else {
                      setSource(e);
                      setCustomerOption([]);
                    }
                  }}
                />
              </div>
              <div className="col-md-3">
                {customer_option?.length != 0 ? (
                  <>
                    <label htmlFor="">
                      Select {source?.label}{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <Select
                      placeholder={`Select ${source?.label}`}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      styles={colourStyles}
                      options={customer_option}
                      value={customer_name}
                      onChange={(e) => setCustomerName(e)}
                    />
                  </>
                ) : null}
              </div>
              <div className="col-md-3 mb-3">
                <label htmlFor="">Phone</label>
                <input
                  type="text"
                  placeholder="Enter Phone"
                  className="form-control"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>
              <div className="col-md-3 mb-3">
                <label htmlFor="">Email Address</label>
                <input
                  type="text"
                  placeholder="Enter Email Address"
                  className="form-control"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="col-md-3 mb-3">
                <label htmlFor="">Website</label>
                <input
                  type="text"
                  placeholder="Enter Website"
                  className="form-control"
                  value={website}
                  onChange={(e) => setWebsite(e.target.value)}
                />
              </div>
              <div className="col-md-3 mb-3">
                <label htmlFor="">Incorporation Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={incorporation}
                  onChange={(e) => setIncorporation(e.target.value)}
                />
              </div>
              <div className="d-flex align-items-center gap-3">
                <div className="col-md-3 mb-3">
                  <label htmlFor="">Profile Image</label>
                  <input
                    type="file"
                    placeholder="Enter Phone"
                    className="form-control"
                    onChange={(e) => setProfile(e.target.files[0])}
                  />
                </div>
                <div className="col-md-4">
                  <img
                    src={`${image}`}
                    width="39"
                    height="39"
                    className="rounded-circle object-fit-cover"
                    alt=""
                  />
                </div>
              </div>
            </Row>

            <Row className="bg-white px-2 py-4 shadow mb-3">
              <h5 className="mb-3">Address</h5>
              <div className="col-md-3 mb-3">
                <label htmlFor="">Country</label>
                <Select
                  placeholder="Select Location"
                  className="basic-multi-select"
                  classNamePrefix="select"
                  styles={colourStyles}
                  options={country_option}
                  value={country}
                  onChange={(e) => onChangeCountry(e)}
                />
              </div>
              <div className="col-md-3 mb-3">
                <label htmlFor="">State</label>
                <Select
                  placeholder="Select State"
                  className="basic-multi-select"
                  classNamePrefix="select"
                  styles={colourStyles}
                  options={state_option}
                  value={state}
                  onChange={(e) => onChangeState(e)}
                />
              </div>
              <div className="col-md-3 mb-3">
                <label htmlFor="">City</label>
                <Select
                  placeholder="Select City"
                  className="basic-multi-select"
                  classNamePrefix="select"
                  styles={colourStyles}
                  options={city_option}
                  value={city}
                  onChange={(e) => setCity(e)}
                />
              </div>
              <div className="col-md-3 mb-3">
                <label htmlFor="">Zip Code</label>
                <input
                  type="text"
                  placeholder="Enter Zip Code"
                  className="form-control"
                  value={zip_code}
                  onChange={(e) => setZipCode(e.target.value)}
                />
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="">Address</label>
                <input
                  type="text"
                  placeholder="Enter Address"
                  className="form-control"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </div>
              <div className="col-md-3 mb-3">
                <label htmlFor="">Groups</label>
                <Select
                  placeholder="Select Groups"
                  className="basic-multi-select"
                  classNamePrefix="select"
                  styles={colourStyles}
                  options={groups_option}
                  value={groups}
                  onChange={(e) => setGroups(e)}
                  isClearable
                />
              </div>
              <div className="col-md-3 mb-3">
                <label htmlFor="">Currency</label>
                <Select
                  placeholder="Select Currency"
                  className="basic-multi-select"
                  classNamePrefix="select"
                  styles={colourStyles}
                  options={currency_option}
                  value={currency}
                  onChange={(e) => setCurrency(e)}
                  isClearable
                />
              </div>
            </Row>
          </form>
        </div>
      </div>

      <div className={`note-sticky-form ${invoice ? "d-block" : "d-none"}`}>
        <Draggable
          handle=".modal-header"
          cancel="input,textarea,button,select,label"
        >
          <ResizableBox
            width={1000}
            style={{
              position: "fixed",
              top: "19%",
              right: "19%",
              zIndex: "1055",
              backgroundColor: "#fff",
            }}
          >
            <div className="modal-header mb-3">
              <h5 className="modal-title mt-0">Invoice Changes</h5>
              <button
                type="button"
                onClick={() => {
                  console.log("Modal closed via X button");
                  modalPromise?.resolve(false);
                  setInvoice(false);
                  setSelectedInvoices([]);
                  setModalPromise(null);
                }}
                className="btn-modal-close pe-1"
              >
                <span aria-hidden="true" className="btn-modal-span">
                  &times;
                </span>
              </button>
            </div>

            <div className="modal-body pe-4">
              <Form
                className="row d-flex flex-column justify-content-center align-items-center"
                onSubmit={(e) => e.preventDefault()}
              >
                <div className="col-md-12 d-flex flex-column">
                  <div className="col-md-12 d-flex mb-4 justify-content-center align-items-center gap-4">
                    <div className="col-4">
                      <img src={confirmImg} className="img-fluid" />
                    </div>
                    <div className="col-8 table-responsive text-start">
                      <div className="col-md-12 d-flex flex-column mb-4 justify-content-start align-items-start heading-text-roles">
                        <h3 className="text-danger text-start">
                          You are about to modify the Customer details
                        </h3>
                        <p className="text-danger text-start text-bold mb-1">
                          These updates will automatically apply to the
                          following Invoices.
                        </p>
                        <p className="text-danger text-start text-bold font-size-12">
                          If you want the changes to apply to specific Invoice,
                          please check before proceeding and it will update Vat No, Company Name, Country, State, City, Address, Zipcode in particular invoices
                        </p>
                        <p className="text-danger text-start text-bold">

                        </p>
                      </div>

                      <div className="table-responsive text-start ticket-close-box">
                        <table className="table mb-0">
                          <thead className="table-white">
                            <tr>
                              <th
                                className="text-center"
                                style={{ width: "18%" }}
                              >
                                Update
                              </th>
                              <th
                                className="text-start"
                                style={{ width: "70%" }}
                              >
                                Invoice
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {invoices.length > 0 ? (
                              invoices.map((inv) => {
                                const invoiceKey = `${inv.id}-${inv.source}`;
                                return (
                                  <tr key={invoiceKey}>
                                    <td>
                                      <div className="text-center">
                                        <input
                                          type="checkbox"
                                          onChange={(e) => {
                                            console.log(
                                              "Invoice key:",
                                              invoiceKey
                                            );

                                            if (
                                              inv.source === "zithasinvoice"
                                            ) {
                                              setZithasInvoice((prev) =>
                                                e.target.checked
                                                  ? [
                                                    ...new Set([
                                                      ...prev,
                                                      inv.id,
                                                    ]),
                                                  ]
                                                  : prev.filter(
                                                    (id) => id !== inv.id
                                                  )
                                              );
                                            } else if (
                                              inv.source === "ztplinvoice"
                                            ) {
                                              setZtplInvoice((prev) =>
                                                e.target.checked
                                                  ? [
                                                    ...new Set([
                                                      ...prev,
                                                      inv.id,
                                                    ]),
                                                  ]
                                                  : prev.filter(
                                                    (id) => id !== inv.id
                                                  )
                                              );
                                            }
                                          }}
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <p className="text-start mb-0">
                                        {inv.tax_inv_no || inv.invoice_number} -{" "}
                                        {company_name || "Company"}
                                        {/* -{" "} */}
                                        {/* ({inv.source}) */}
                                      </p>
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan="2" className="text-center">
                                  No invoices found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="my-2 text-end pe-0">
                  <button
                    className="btn btn-save btn-label"
                    onClick={async (e) => {
                      e.preventDefault();

                      Swal.fire({
                        title: "Are you sure?",
                        text: "You want to update the selected invoices with the new customer details?",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Yes, update",
                        cancelButtonText: "No, cancel",
                      }).then(async (willDelete) => {
                        if (willDelete?.isConfirmed) {
                          try {
                            console.log(
                              "Selected invoice IDs:",
                              selectedInvoices
                            );
                            await onEditCustomer(e);

                            modalPromise?.resolve(true);
                            setInvoice(false);
                            setSelectedInvoices([]);
                            setModalPromise(null);

                            Swal.fire({
                              icon: "success",
                              text: "Invoices updated successfully",
                            });
                          } catch (error) {
                            console.error("Invoice update failed:", error);
                            modalPromise?.reject(error);
                            setInvoice(false);
                            setSelectedInvoices([]);
                            setModalPromise(null);

                            Swal.fire({
                              icon: "error",
                              text: "Failed to update invoices",
                            });
                          }
                        } else {
                          console.log("Modal cancelled via Swal");
                          modalPromise?.resolve(false);
                          setInvoice(false);
                          setSelectedInvoices([]);
                          setModalPromise(null);
                        }
                      });
                    }}
                  >
                    <i className="fas fa-save me-2 label-icon"></i>
                    Save
                  </button>

                  <a
                    onClick={() => {
                      console.log("Modal cancelled via Cancel button");
                      modalPromise?.resolve(false);
                      setInvoice(false);
                      setSelectedInvoices([]);
                      setModalPromise(null);
                    }}
                    className="btn ms-md-2 btn-red btn-label"
                  >
                    <i className="dripicons-cross me-2 icon-center label-icon"></i>
                    CANCEL
                  </a>
                </div>
              </Form>
            </div>
          </ResizableBox>
        </Draggable>
      </div>
    </React.Fragment>
  );
};

export default CustomerDetail;
